import React from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import {Heading, ReadyIcon} from '@edume/magnificent';

import styles from './styles.module.scss';

const TitleBlock = ({
  title,
  optionalText,
  hasIcon,
  isValid,
  dataAutomation,
}) => (
  <div styleName='title-block'>
    <div styleName='title'>
      {hasIcon && (
        <ReadyIcon
          isValid={isValid}
          size='small'
          dataAutomation={dataAutomation}
        />
      )}
      <Heading as='h6' size='snail' weight='medium' colour='textPrimary'>
        {title}
      </Heading>
    </div>
    {optionalText && <span styleName='optional'>{optionalText}</span>}
  </div>
);

TitleBlock.propTypes = {
  title: PropTypes.string.isRequired,
  optionalText: PropTypes.string,
  hasIcon: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  dataAutomation: PropTypes.string.isRequired,
};

export default CSSModules(TitleBlock, styles);
